import { bootPdpSideNameValidation } from "./adapters/pdp";

bootPdpSideNameValidation();